// Source: https://github.com/thoughtspile/VKUI/blob/master/src/lib/useIsomorphicLayoutEffect.ts

import { useEffect, useLayoutEffect } from 'react'
import { canUseDOM } from '@pepper/utils/src/function/dom'

export const useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect
